/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect, useRef, Fragment } from "react";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import {
  Card,
  Space,
  Typography,
  Tag,
  Spin,
  Popover,
  Image,
  Dropdown,
  Button,
} from "antd";
import { CloseCircleOutlined, MoreOutlined } from "@ant-design/icons";
// import DayOffIcon from "../../../../atoms/CustomIcons/DayOffIcon";
import FlagIcon from "../../../../atoms/CustomIcons/FlagIcon";
// import HomeIcon from "../../../../atoms/CustomIcons/HomeIcon";
// import ChangeShift from "../../../../atoms/CustomIcons/ChangeShift";
import RescheduleIcon from "../../../../atoms/CustomIcons/RescheduleIcon";
// import MoveIcon from "../../../../atoms/CustomIcons/MoveIcon";
// import RouteCalculate from "../../../../atoms/CustomIcons/RouteCalculate";
import UnscheduleIcon from "../../../../atoms/CustomIcons/UnscheduleIcon";
import ConfirmIcon from "../../../../atoms/CustomIcons/ConfirmIcon";
// import RouteIcon from "../../../../atoms/CustomIcons/RouteIcon";
import { PopUp } from "../../../../atoms/PopUp";
import MakeDayOff from "../MakeDayOff";
import EditStartFinishPoint from "../EditStartFinishPoint";
import MoveCrewScheduleBy from "../MoveCrewScheduleBy";
import ChangeShiftYardTime from "../ChangeShiftYardTime";
import ConfirmDelete from "../../../../atoms/ConfirmDelete";
import { SuccessMessage } from "../../../../atoms/Toasts/SuccessMessage";
import HourCard from "../KanbanBoard/HourCard";
import { AxiosError } from "axios";
import {
  confirmWorkOrders,
  moveScheduleToDate,
  setDayOff,
  unscheduleAllRemainingVisits,
} from "../../ducks/services";
import { ErrorMessage } from "../../../../atoms/Toasts/ErrorMessage";
import DayOffIcon from "../../../../atoms/CustomIcons/DayOffIcon";
import HomeIcon from "../../../../atoms/CustomIcons/HomeIcon";
import MoveIcon from "../../../../atoms/CustomIcons/MoveIcon";
import { useAppDispatch } from "../../../../config/hooks";
import { getSchedulingFormData } from "../../ducks/actions";
import RescheduleRemainingOrWhole from "../RescheduleRemainingOrWhole";
import ChangeShift from "../../../../atoms/CustomIcons/ChangeShift";
import CrewCard from "../KanbanBoard/CrewCard";
// import { AxiosError } from "axios";
// import { ErrorMessage } from "../../../../atoms/Toasts/ErrorMessage";
// import { setDayOn } from "../../ducks/services";

dayjs.extend(duration);

interface WeatherCondition {
  text: string;
  icon: string;
  code: number;
}

interface DayForecast {
  maxtemp_c: number;
  maxtemp_f: number;
  mintemp_c: number;
  mintemp_f: number;
  avgtemp_c: number;
  avgtemp_f: number;
  condition: WeatherCondition;
  daily_will_it_rain: number;
  daily_chance_of_rain: number;
  daily_will_it_snow: number;
  daily_chance_of_snow: number;
  maxwind_kph: number;
  avghumidity: number;
}

interface ForecastDay {
  date: string;
  date_epoch: number;
  day: DayForecast;
}

interface Forecast {
  forecastday: ForecastDay[];
}

interface Location {
  name: string;
  region: string;
  country: string;
  lat: number;
  lon: number;
  tz_id: string;
  localtime_epoch: number;
  localtime: string;
}

interface WeatherApiResponse {
  location: Location;
  current: unknown;
  forecast?: Forecast;
  forecastday?: ForecastDay[];
}

interface Coordinates {
  lat: number;
  lng: number;
}

// interface VisitExtendedProps {
//   type: "visit" | "drive";
//   durationMinutes?: number;
//   driveTimeMinutes?: number;
//   location?: string;
//   nextVisitLocation?: string;
//   backgroundColor?: string;
//   textColor?: string;
//   borderColor?: string;
// }

interface FullCalendarEvent {
  id: string;
  name?: string;
  title?: string;
  start: string;
  end: string;
  date?: string;
  allDay?: boolean;
  editable?: boolean;
  origin?: Coordinates;
  extendedProps?: {
    workOrders?: any[]; // Array of work order objects
  };
}

interface CustomDayHeaderProps {
  date: Date;
  events: FullCalendarEvent[];
  hoursData?: any;
  crewData?: any;
  setLoading: (loading: boolean) => void;
  normalCard?: boolean;
  weekStartDate?: any;
  selectedCrewValue?: string;
  loading: boolean;
  crewOptions: { label: string; value: string }[];
  dayEvents?: any;
  crewArrayForCalendar: any;
  crewDrop?: any;
}

// const roundToHalfOrWhole = (value: number) => {
//   const decimal = value % 1;

//   if (decimal === 0) return value;
//   if (decimal <= 0.5) return Math.floor(value) + 0.5;
//   return Math.ceil(value);
// };

export default function CustomDayHeader({
  date,
  setLoading,
  weekStartDate,
  loading,
  crewOptions,
  selectedCrewValue,
  dayEvents,
  crewData,
  crewArrayForCalendar,
  crewDrop,
}: CustomDayHeaderProps) {
  const dayjsDate = dayjs(date);
  const dayOfWeek = dayjsDate.format("ddd");
  const dayOfMonth = dayjsDate.format("DD");

  // console.log("crewData in header", crewData);
  // console.log("hoursData in header", hoursData);

  // console.log("events in header", events);
  // const eventsForThisDay = hoursData?.filter((event: any) => {
  //   return dayjs(event.date).isSame(dayjsDate, "day");
  // });

  // let totalScheduledMinutes = 0;
  // eventsForThisDay?.forEach((event: any) => {
  //   if (event.hours) {
  //     totalScheduledMinutes += event.hours;
  //   }
  // });

  // let totalScheduledHours = 0;
  // if (totalScheduledMinutes > 0) {
  //   const rawHours = totalScheduledMinutes / 60;
  //   totalScheduledHours = roundToHalfOrWhole(rawHours);
  // }

  // console.log("arg in header", dayEvents);

  const [weather, setWeather] = useState<{
    high: number;
    low: number;
    icon: string;
    precipitationChance?: number;
    windKph?: number;
    humidity?: number;
  } | null>(null);
  const dispatch = useAppDispatch();
  const [weatherLoading, setWeatherLoading] = useState<boolean>(true);
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const [confirmAllWO, setConfirmAllWO] = useState(false);
  const [rescheduleVisitModal, setRescheduleVisitModal] = useState(false);
  const [editStartPointModal, setEditStartPointModal] = useState(false);
  const [editFinishPointModal, setEditFinishPointModal] = useState(false);
  const [changeShiftYardTimeModal, setChangeShiftYardTimeModal] =
    useState(false);
  const [moveCrewScheduleByModal, setMoveCrewScheduleByModal] = useState(false);
  const [makeDayOffModal, setMakeDayOffModal] = useState(false);
  // const [makeDayOnModal, setMakeDayOnModal] = useState(false);
  const [dayOffData, setDayOffData] = useState<any>(null);
  const [confirmAllUnschedule, setConfirmAllUnschedule] = useState(false);

  const today = dayjs();
  const selectedDate = dayjs(date).format("YYYY-MM-DD");
  const comparisonDate = dayjs(selectedDate);

  const moveScheduleToDateFunc = (days: string) => {
    setLoading(true);
    const payload = {
      schedule_id: dayEvents?.[0]?.scheduleId,
      date: dayjs(selectedDate).add(Number(days), "day").format("YYYY-MM-DD"),
    };
    moveScheduleToDate(payload)
      .then(() => {
        const payload = {
          date: dayjs(weekStartDate).format("YYYY-MM-DD"),
        };
        dispatch(getSchedulingFormData(payload));
        SuccessMessage("Scheduled moved");
        setConfirmAllWO(false);
        setLoading(false);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
          setLoading(false);
        } else {
          ErrorMessage("Something went wrong");
          setLoading(false);
        }
      });
  };

  const discardChanges = () => {
    setLoading(true);

    const payload = {
      date: dayjs(weekStartDate).format("YYYY-MM-DD"),
    };
    dispatch(getSchedulingFormData(payload));

    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const btnConfirmAllWorkOrders = async () => {
    setLoading(true);
    const payload = {
      schedule_id: dayEvents?.[0]?.scheduleId,
    };
    confirmWorkOrders(payload)
      .then(() => {
        const payload = {
          date: dayjs(weekStartDate).format("YYYY-MM-DD"),
        };
        dispatch(getSchedulingFormData(payload));
        SuccessMessage("Work orders confirmed");
        setConfirmAllWO(false);
        setLoading(false);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
          setLoading(false);
        } else {
          ErrorMessage("Something went wrong");
          setLoading(false);
        }
      });
  };

  const btnRescheduleVisits = async () => {
    SuccessMessage("Visits rescheduled");
    setRescheduleVisitModal(false);
  };
  const btnChangeShiftYardTime = async () => {
    SuccessMessage("Shift start time changed");
    setChangeShiftYardTimeModal(false);
  };

  const btnEditStartPoint = async () => {
    SuccessMessage("Start point changed");
    setEditStartPointModal(false);
  };
  const btnEditFinishPoint = async () => {
    SuccessMessage("Finish point changed");
    setEditFinishPointModal(false);
  };
  const btnMakeDayOff = async () => {
    setLoading(true);
    const payload = {
      crew_id: dayOffData === "only" ? selectedCrewValue : undefined,
      date: dayjs(selectedDate).format("YYYY-MM-DD"),
    };
    setDayOff(payload)
      .then(() => {
        const payload = {
          date: dayjs(weekStartDate).format("YYYY-MM-DD"),
        };
        dispatch(getSchedulingFormData(payload));
        SuccessMessage("Day off scheduled");
        setMakeDayOffModal(false);
        setLoading(false);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
          setLoading(false);
        } else {
          ErrorMessage("Something went wrong");
          setLoading(false);
        }
      });
  };

  // console.log("dayEvents in header:", dayEvents, dayEvents?.[0]?.scheduleId);

  const unscheduleAllRemainingVisitsApi = async () => {
    setLoading(true);
    const payload = {
      schedule_id: dayEvents?.[0]?.scheduleId,
    };

    unscheduleAllRemainingVisits(payload)
      .then(() => {
        setConfirmAllUnschedule(false);
        const payload = {
          date: dayjs(weekStartDate).format("YYYY-MM-DD"),
        };
        dispatch(getSchedulingFormData(payload));
        SuccessMessage("All remaining visits unscheduled");
        setLoading(false);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
          setLoading(false);
        } else {
          ErrorMessage("Something went wrong");
          setLoading(false);
        }
      });
  };

  const unscheduleAllRemainingVisitsPopUp = {
    visibility: confirmAllUnschedule,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setConfirmAllUnschedule(false)}
        heading="Confirm unschedule"
        paragraph="Are you sure you want to unschedule"
        btnText="Confirm"
        btnApi={unscheduleAllRemainingVisitsApi}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setConfirmAllUnschedule(false),
  };

  const confirmAllWorkOrdersPopUp = {
    visibility: confirmAllWO,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setConfirmAllWO(false)}
        heading="Confirm all work orders for this route"
        paragraph={
          <Fragment>
            This will mark all work orders completed by the crew as confirmed.
            <br />
            <br />
            Are you sure you want to proceed?
          </Fragment>
        }
        btnText="Confirm"
        loading={loading}
        isArchivePopup
        btnApi={btnConfirmAllWorkOrders}
      />
    ),
    width: 480,
    onCancel: () => setConfirmAllWO(false),
  };

  const rescheduleVisit = {
    visibility: rescheduleVisitModal,
    content: (
      <RescheduleRemainingOrWhole
        onClose={() => setRescheduleVisitModal(false)}
        btnApi={btnRescheduleVisits}
        loading={loading}
        scheduleId={dayEvents?.[0]?.scheduleId}
        crewId={selectedCrewValue}
        setLoading={setLoading}
        oldDate={dayjs(date)}
        crewOptions={crewOptions}
        weekStartDate={weekStartDate}
      />
    ),
    width: 360,
    onCancel: () => setRescheduleVisitModal(false),
  };
  const changeShiftYardTime = {
    visibility: changeShiftYardTimeModal,
    content: (
      <ChangeShiftYardTime
        onClose={() => setChangeShiftYardTimeModal(false)}
        btnApi={btnChangeShiftYardTime}
        loading={false}
      />
    ),
    width: 385,
    onCancel: () => setChangeShiftYardTimeModal(false),
  };
  const moveCrewScheduleBy = {
    visibility: moveCrewScheduleByModal,
    content: (
      <MoveCrewScheduleBy
        onClose={() => setMoveCrewScheduleByModal(false)}
        loading={loading}
        setLoading={setLoading}
        selectedDate={selectedDate}
        scheduleId={dayEvents?.[0]?.scheduleId}
        weekStartDate={weekStartDate}
      />
    ),
    width: 480,
    onCancel: () => setMoveCrewScheduleByModal(false),
  };
  const editStartPoint = {
    visibility: editStartPointModal,
    content: (
      <EditStartFinishPoint
        onClose={() => setEditStartPointModal(false)}
        btnApi={btnEditStartPoint}
        loading={loading}
        scheduleId={dayEvents?.[0]?.scheduleId}
        isStartPoint={true}
        title="Edit start point"
        selectedDate={selectedDate}
        setLoading={setLoading}
        paragraph="By default, the crew starts their day at their assigned yard. When needed, you can change it to a different location."
      />
    ),
    width: 480,
    onCancel: () => setEditStartPointModal(false),
  };
  const editFinishPoint = {
    visibility: editFinishPointModal,
    content: (
      <EditStartFinishPoint
        onClose={() => setEditFinishPointModal(false)}
        btnApi={btnEditFinishPoint}
        loading={loading}
        scheduleId={dayEvents?.[0]?.scheduleId}
        isStartPoint={false}
        title="Edit finish point"
        selectedDate={selectedDate}
        setLoading={setLoading}
        paragraph="By default, the crew finishes their day at their assigned yard. When needed, you can change it to a different location."
      />
    ),
    width: 480,
    onCancel: () => setEditFinishPointModal(false),
  };
  const makeDayOff = {
    visibility: makeDayOffModal,
    content: (
      <MakeDayOff
        onClose={() => setMakeDayOffModal(false)}
        btnApi={btnMakeDayOff}
        setDayOffData={setDayOffData}
        dayOffData={dayOffData}
        loading={loading}
        selectedDate={selectedDate}
        column={"column"}
      />
    ),
    width: 480,
    onCancel: () => setMakeDayOffModal(false),
  };

  const items = [
    // {
    //   key: "1",
    //   label: (
    //     <Button
    //       type="text"
    //       className="no-hover"
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         if (dropdownRef.current) {
    //           dropdownRef?.current?.click();
    //         }
    //       }}
    //     >
    //       <RouteIcon /> Show route on a map
    //     </Button>
    //   ),
    // },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setConfirmAllWO(true);
          }}
        >
          <ConfirmIcon /> Confirm all work orders
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setRescheduleVisitModal(true);
          }}
        >
          <RescheduleIcon /> Reschedule remaining visits
        </Button>
      ),
    },
    {
      key: "4",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            setConfirmAllUnschedule(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
        >
          <UnscheduleIcon /> Unschedule all remaining visits
        </Button>
      ),
    },
    // {
    //   key: "5",
    //   label: (
    //     <Button
    //       type="text"
    //       className="no-hover"
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         if (dropdownRef.current) {
    //           dropdownRef?.current?.click();
    //         }
    //       }}
    //     >
    //       <TimeSheetIcon /> Open timesheet
    //     </Button>
    //   ),
    // },
    // {
    //   key: "6",
    //   label: (
    //     <Button
    //       type="text"
    //       className="no-hover"
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         if (dropdownRef.current) {
    //           dropdownRef?.current?.click();
    //         }
    //         setEditFinishPointModal(true);
    //       }}
    //     >
    //       <FlagIcon /> Edit finish point
    //     </Button>
    //   ),
    // },
    // {
    //   key: "7",
    //   label: (
    //     <Button
    //       type="text"
    //       className="no-hover"
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         if (dropdownRef.current) {
    //           dropdownRef?.current?.click();
    //         }
    //         setEditStartPointModal(true);
    //       }}
    //     >
    //       <HomeIcon /> Edit start point
    //     </Button>
    //   ),
    // },
  ];

  const itemsFuture = [
    // {
    //   key: "1",
    //   label: (
    //     <Button
    //       type="text"
    //       className="no-hover"
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         // if (dropdownRef.current) {
    //         //   dropdownRef?.current?.click();
    //         // }
    //       }}
    //     >
    //       <RouteCalculate /> Calculate route
    //     </Button>
    //   ),
    // },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            discardChanges();
          }}
        >
          <CloseCircleOutlined /> Discard unpublished changes
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setRescheduleVisitModal(true);
          }}
        >
          <MoveIcon /> Reschedule the whole day
        </Button>
      ),
    },
    {
      key: "4",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            setConfirmAllUnschedule(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
        >
          <UnscheduleIcon /> Unschedule all remaining visits
        </Button>
      ),
    },
    {
      key: "5",
      label: (
        <Popover
          arrow={false}
          content={
            <>
              <Button
                type="text"
                className="no-hover"
                onClick={() => moveScheduleToDateFunc("1")}
              >
                1 day forward
              </Button>
              <Button
                type="text"
                className="no-hover"
                onClick={() => moveScheduleToDateFunc("2")}
              >
                2 days forward
              </Button>
              <Button
                type="text"
                className="no-hover"
                onClick={(e) => {
                  e.stopPropagation();
                  if (dropdownRef.current) {
                    dropdownRef?.current?.click();
                  }
                  setMoveCrewScheduleByModal(true);
                }}
              >
                Custom period ...
              </Button>
            </>
          }
          // trigger="click"
          placement="rightTop"
          getPopupContainer={(trigger) =>
            trigger.parentElement || document.body
          }
        >
          <Button type="text" className="no-hover">
            <RescheduleIcon /> Move crew’s schedule by ...
          </Button>
        </Popover>
      ),
    },
    {
      key: "6",
      disabled: true,
      label: (
        <Button
          type="text"
          className="no-hover"
          disabled
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setChangeShiftYardTimeModal(true);
          }}
        >
          <ChangeShift /> Change shift & yard time
        </Button>
      ),
    },
    {
      key: "7",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setEditStartPointModal(true);
          }}
        >
          <HomeIcon /> Edit start point
        </Button>
      ),
    },
    {
      key: "8",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setEditFinishPointModal(true);
          }}
        >
          <FlagIcon /> Edit finish point
        </Button>
      ),
    },
    {
      key: "9",
      disabled: true,
      label: (
        <Button
          type="text"
          className="no-hover"
          disabled
          onClick={(e) => {
            e.stopPropagation();
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
            setMakeDayOffModal(true);
          }}
        >
          <DayOffIcon /> Make a day-off
        </Button>
      ),
    },
  ];

  const fetchMockData = async () => {
    const API_KEY = "d9bd73568247491c88e153434252307";
    const LOCATION_QUERY = "Dallas";

    const fetchWeatherData = async () => {
      setWeatherLoading(true);
      let API_ENDPOINT = "";
      const targetDateStr = dayjsDate.format("YYYY-MM-DD");
      const today = dayjs();
      const diffDays = dayjsDate.diff(today, "day");

      if (diffDays >= 0 && diffDays <= 9) {
        API_ENDPOINT = `https://api.weatherapi.com/v1/forecast.json?key=${API_KEY}&q=${LOCATION_QUERY}&days=14`;
      } else if (dayjsDate.isBefore(today, "day")) {
        API_ENDPOINT = `https://api.weatherapi.com/v1/history.json?key=${API_KEY}&q=${LOCATION_QUERY}&dt=${targetDateStr}`;
      } else {
        setWeather(null);
        setWeatherLoading(false);
        console.warn(
          `Weather data not available for date: ${targetDateStr} (too far in future).`
        );
        return;
      }

      try {
        const response = await fetch(API_ENDPOINT);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data: WeatherApiResponse = await response.json();

        let forecastForDay: DayForecast | undefined;

        if (data.forecast && data.forecast.forecastday) {
          forecastForDay = data.forecast.forecastday.find(
            (fd) => fd.date === targetDateStr
          )?.day;
        } else if (data.forecastday && data.forecastday.length > 0) {
          forecastForDay = data.forecastday?.[0].day;
        }

        if (forecastForDay) {
          const highTemp = forecastForDay.maxtemp_f;
          const lowTemp = forecastForDay.mintemp_f;
          const weatherIcon = forecastForDay.condition?.icon;
          const precipitationChance = forecastForDay.daily_chance_of_rain;
          const windKph = forecastForDay.maxwind_kph;
          const humidity = forecastForDay.avghumidity;

          setWeather({
            high: highTemp,
            low: lowTemp,
            icon: weatherIcon,
            precipitationChance,
            windKph,
            humidity,
          });
        } else {
          console.warn(`No weather data found for date: ${targetDateStr}`);
          setWeather(null);
        }
      } catch (error) {
        console.error("Failed to fetch weather data:", error);
        setWeather(null);
      } finally {
        setWeatherLoading(false);
      }
    };

    fetchWeatherData();
  };

  useEffect(() => {
    fetchMockData();
  }, []);

  const weatherDetailsContent = (
    <div>
      <Typography.Title level={4} style={{ margin: "0 0 4px 0" }}>
        Weather details
      </Typography.Title>
      {weather ? (
        <Space direction="vertical" size={12}>
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <Image
              src={weather.icon}
              alt="Weather Icon"
              width={32}
              preview={false}
            />
            <Tag className="default_tag">
              Highest:{" "}
              <span style={{ fontWeight: "600", color: "#F06400" }}>
                {Math.round(weather.high)}°
              </span>
            </Tag>
            <Tag className="default_tag">
              Lowest:{" "}
              <span style={{ fontWeight: "600", color: "#2098EE" }}>
                {Math.round(weather.low)}°
              </span>
            </Tag>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <div style={{ width: "90px" }}>
              <Typography.Text
                style={{
                  fontWeight: "500",
                  fontSize: "12px",
                  color: "#151718",
                }}
              >
                Precipitation
              </Typography.Text>
              <br />
              <div className="detailsData">
                <Image
                  src="/images/schedule/precipitation.svg"
                  preview={false}
                />
                <Typography.Text>
                  {weather.precipitationChance
                    ? Math.round(weather.precipitationChance)
                    : 0}{" "}
                  <span>%</span>
                </Typography.Text>
              </div>
            </div>
            <div style={{ width: "90px" }}>
              <Typography.Text
                style={{
                  fontWeight: "500",
                  fontSize: "12px",
                  color: "#151718",
                }}
              >
                Wind
              </Typography.Text>
              <br />
              <div className="detailsData">
                <Image src="/images/schedule/windy.svg" preview={false} />
                <Typography.Text>
                  {weather.windKph ? Math.round(weather.windKph) : 0}{" "}
                  <span>km/h</span>
                </Typography.Text>
              </div>
            </div>
            <div style={{ width: "90px" }}>
              <Typography.Text
                style={{
                  fontWeight: "500",
                  fontSize: "12px",
                  color: "#151718",
                }}
              >
                Humidity
              </Typography.Text>
              <br />
              <div className="detailsData">
                <Image src="/images/schedule/humidity.svg" preview={false} />
                <Typography.Text>
                  {weather.humidity ? Math.round(weather.humidity) : 0}
                  <span>%</span>
                </Typography.Text>
              </div>
            </div>
          </div>
        </Space>
      ) : (
        <Typography.Text type="secondary">
          No detailed weather data available.
        </Typography.Text>
      )}
    </div>
  );

  // console.log("dayEvents:", crewData, dayEvents);

  // Filter dayEvents according to the date field if there are 3 events on same day pick first one
  const dateEventsFiltered = dayEvents?.filter((event: any) =>
    dayjs(event.date).isSame(selectedDate, "day")
  );

  // Want to check if selected crew has event on week
  const selectedCrewHasEvent = crewData?.some(
    (event: any) => event?.crew_id === selectedCrewValue
  );

  const column = {
    id:
      selectedCrewHasEvent && dateEventsFiltered?.length > 0
        ? dateEventsFiltered?.[0]?.scheduleId || null
        : null,
    date: selectedDate,
    hasEvent: dateEventsFiltered?.length > 0,
    crewAttendances:
      selectedCrewHasEvent && dayEvents?.length > 0
        ? dayEvents?.[0]?.crewAttendances || []
        : [],
    crewLeader: crewArrayForCalendar?.crewLeader || null,
    crewMembers: crewArrayForCalendar?.crewMembers || [],
  };

  // console.log("crewArrayForCalendar:dayEvents", dayEvents);
  return (
    <Card className="calendarHeaderCard">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: "8px",
        }}
      >
        <Tag className="headerTag" style={{ height: "26px" }}>
          <span>{dayOfWeek}</span>
          <span style={{ fontWeight: 700 }}>{dayOfMonth}</span>
        </Tag>
        <div style={{ display: "flex", marginLeft: "auto" }}>
          <Popover
            content={weatherDetailsContent}
            title={null}
            trigger="click"
            placement="bottomRight"
            overlayClassName="weatherPopoverOpen"
          >
            <Space size={4} style={{ cursor: "pointer" }}>
              {weatherLoading ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "32px",
                    height: "32px",
                  }}
                >
                  <Spin size="small" />
                </div>
              ) : weather ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "column",
                      gap: "1px",
                    }}
                  >
                    <Typography.Text
                      type="secondary"
                      style={{
                        fontSize: "11px",
                        color: "#151718",
                        fontWeight: "400",
                      }}
                    >
                      H: {Math.round(weather.high)}°
                    </Typography.Text>

                    <Typography.Text
                      type="secondary"
                      style={{
                        fontSize: "11px",
                        color: "#151718",
                        fontWeight: "400",
                      }}
                    >
                      L: {Math.round(weather.low)}°
                    </Typography.Text>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "32px",
                      height: "32px",
                    }}
                  >
                    <Image
                      src={weather.icon}
                      alt="Weather Icon"
                      width={32}
                      preview={false}
                    />
                  </div>
                </>
              ) : (
                <div style={{ height: "36px" }}>
                  <Image
                    src="/images/schedule/not-available-icon.svg"
                    preview={false}
                  />
                </div>
              )}
            </Space>
          </Popover>
          <div
            className="column_actions"
            style={{ width: "24px", height: "24px" }}
          >
            <Dropdown
              menu={{
                items: comparisonDate.isAfter(today, "day")
                  ? (() => {
                      // For Saturday (6) and Sunday (0), remove 8th object (index 7)
                      if (dayjsDate.day() === 0 || dayjsDate.day() === 6) {
                        return itemsFuture.filter((_, idx) => idx !== 7);
                      }
                      // For other days, remove 9th object (index 8)
                      return itemsFuture.filter((_, idx) => idx !== 8);
                    })()
                  : items,
              }}
              trigger={["click"]}
              placement="bottomLeft"
              className="actionButton"
            >
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onKeyDown={(e) => e.stopPropagation()}
                className="white_border"
                icon={<MoreOutlined />}
                ref={dropdownRef}
                style={{ width: "100%", height: "100%" }}
              />
            </Dropdown>
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "10px",
          paddingLeft: "6px",
          paddingRight: "6px",
        }}
      >
        <HourCard
          column={column}
          isWeekend={
            dayjs(selectedDate).day() === 0 || dayjs(selectedDate).day() === 6
          }
        />
        <CrewCard
          column={column}
          crewDrop={crewDrop}
          selectedDate={selectedDate}
          setLoading={setLoading}
          loading={loading}
          hideEditIcon={!column?.hasEvent}
          isWeekend={
            dayjs(selectedDate).day() === 0 || dayjs(selectedDate).day() === 6
          }
          weekStartDate={weekStartDate}
        />
        {/* {normalCard ? (
          <>
            <HourCardWithoutPop
              column={true}
              isWeekend={isWeekend}
              actualHours={
                Array.isArray(hoursData)
                  ? hoursData.find((h: any) =>
                      dayjs(h.date).isSame(dayjsDate, "day")
                    )?.hours *
                      (crewData?.crewMembers
                        ? crewData?.crewMembers?.length + 1
                        : crewData?.length) || 0
                  : 0
              }
              totalHours={
                crewData?.crewMembers
                  ? (crewData?.crewMembers?.length > 0
                      ? crewData?.crewMembers?.length + 1
                      : 0) * 8
                  : crewData?.length * 8 || 0
              }
              // selectedDate={date}
              // index={crewData?.length > 0 && crewData?.[0]?.index}
            />
            <CrewCardWithoutPop
              isWeekend={isWeekend}
              selectedDate={date}
              crewArray={crewData}
            />
          </>
        ) : ( */}
        <>
          {/* <HourCard
              column={true}
              actualHours={
                Array.isArray(hoursData)
                  ? hoursData.find((h: any) =>
                      dayjs(h.date).isSame(dayjsDate, "day")
                    )?.hours *
                      (crewData?.crewMembers
                        ? crewData?.crewMembers?.length + 1
                        : crewData?.length) || 0
                  : 0
              }
              totalHours={
                crewData?.crewMembers
                  ? (crewData?.crewMembers?.length > 0
                      ? crewData?.crewMembers?.length + 1
                      : 0) * 8
                  : crewData?.length * 8 || 0
              }
            />
            <CrewCardWithoutPop
              isWeekend={isWeekend}
              selectedDate={date}
              crewArray={crewData}
            /> */}
          {/* <CrewCard
              isWeekend={isWeekend}
              crewCount={crewData?.length}
              column={crewData?.length > 0 && crewData}
              selectedDate={date}
              crewArray={crewData}
              weekStartDate={weekStartDate}
              calendar={true}
            /> */}

          {/* <CrewCard
          column={column}
          crewDrop={crewDrop}
          setColumns={setColumns}
          allColumns={allColumns}
          selectedDate={selectedDate}
          crewArray={column?.crewAttendances || []}
          crewLength={
            column?.visits?.length > 0
              ? column?.crewAttendances?.length ?? 1
              : 0
          }
          setLoading={setLoading}
          loading={loading}
        /> */}
        </>
        {/* )} */}
      </div>
      <PopUp {...confirmAllWorkOrdersPopUp} />
      <PopUp {...rescheduleVisit} />
      <PopUp {...changeShiftYardTime} />
      <PopUp {...moveCrewScheduleBy} />
      <PopUp {...editStartPoint} />
      <PopUp {...editFinishPoint} />
      <PopUp {...makeDayOff} />
      <PopUp {...unscheduleAllRemainingVisitsPopUp} />
      {/* <PopUp {...makeDayOn} /> */}
    </Card>
  );
}
